export default "__VITE_ASSET__86310960__"